import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const fallbackLng = {
  'en-US': ['en'],
  'en-GB': ['en'],
  'fr-CA': ['fr'],
  'default': ['en'] // Set the default language here
};

export const availableLanguages = ['en', 'fr', 'en-US', 'fr-CA'];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng,
    ns: ["translation", "aiFeatureLang"], // Preload namespaces
    defaultNS: "translation", // Default namespace
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      checkWhitelist: true,
    },
    debug: false,
    whitelist: availableLanguages,
    interpolation: {
      escapeValue: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
